export default __webpack_public_path__ + "static/media/bg-rest-and-rejuvenate-subheader.4aed9b13.jpg";